export const API_ENDPOINTS = {
  SEND_SMS: '/sendsms',
  CALCULATE_PRICE: '/calculatePrice',
  REVIEWS: '/reviews',
};

export default API_ENDPOINTS;
